import { IAxiosInstance } from "../../../AbstractApiClient/AbstractApiClient";
import { IApiResponse } from "../../../AbstractApiClient/IApiResponse";

export const savePartnerSignature = (axios: IAxiosInstance) => {
  return async (partnerId: string, signature: string) => {
    const response = await axios.noRetry.post<IApiResponse<string>>(
      `/api/partners/${partnerId}/signature`,
      {
        signature,
      }
    );
    const resData = response.data;
    if (!resData.success) {
      throw new Error("Something went wrong");
    }
    return resData.data;
  };
};
